export const SCOUTING_FORM = 'scoutingForm';
export const OPERATION_NOT_ALLOWED = 'operationNotAllowed';
export const REGION_REPORT = 'regionReport';
export const REGION_NOTE = 'regionNote';
